<template>
  <svg
    width="31px"
    height="23px"
    viewBox="0 0 31 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Bitmap</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Home" transform="translate(-1709.000000, -3824.000000)">
        <g id="Footer" transform="translate(80.000000, 3433.000000)">
          <g id="Group-15" transform="translate(1629.000000, 377.000000)">
            <image
              id="Bitmap"
              x="0"
              y="14"
              width="30.6666667"
              height="23"
              xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAkCAYAAADPRbkKAAABfGlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGAqSSwoyGFhYGDIzSspCnJ3UoiIjFJgv8PAzcDDIMRgxSCemFxc4BgQ4MOAE3y7xsAIoi/rgsxK8/x506a1fP4WNq+ZclYlOrj1gQF3SmpxMgMDIweQnZxSnJwLZOcA2TrJBUUlQPYMIFu3vKQAxD4BZIsUAR0IZN8BsdMh7A8gdhKYzcQCVhMS5AxkSwDZAkkQtgaInQ5hW4DYyRmJKUC2B8guiBvAgNPDRcHcwFLXkYC7SQa5OaUwO0ChxZOaFxoMcgcQyzB4MLgwKDCYMxgwWDLoMjiWpFaUgBQ65xdUFmWmZ5QoOAJDNlXBOT+3oLQktUhHwTMvWU9HwcjA0ACkDhRnEKM/B4FNZxQ7jxDLX8jAYKnMwMDcgxBLmsbAsH0PA4PEKYSYyjwGBn5rBoZt5woSixLhDmf8xkKIX5xmbARh8zgxMLDe+///sxoDA/skBoa/E////73o//+/i4H2A+PsQA4AJHdp4IxrEg8AAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAADCgAwAEAAAAAQAAACQAAAAAbZ9/dAAAAO9JREFUWAljVCo97cX4/9/M//8ZZBioBA7eaaOSSbiNYWRkfPL///90Jmo7HreV1JUBOl4G6ImZTNQMeeo6kbBpIE+wICu722MG5yqXnIKzSRWX2bABrpfWDCZaW0Br84e8BxiVik/+p3Yo0aMUgrl5yMfAkPfAaCkES4sDRQ/5JDRaCg1U0oHZO+ST0GgpBIvKgaKHfBIaLYUGKunA7B36SQjYLaN6cxoWOvSgh3wMDHkPMD729x9NQvRI67jsGPpJaLQUwhW3dBIf+klotBSiU1LBZc3QT0LDoRR6git6hoD4E1ASSgfioegJkJvTAV91XPCesJ+TAAAAAElFTkSuQmCC"
            ></image>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "country-flag",
};
</script>

<style scoped></style>
